import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { BackHistoryStorage } from '../utils/helpers/BackHistoryStorage';

export const useGoBack = (): (() => boolean) => {
  const router = useRouter();

  return useCallback(() => {
    const hasHistory = BackHistoryStorage.getBackHistoryStorage();

    if (hasHistory) {
      router.back();
      return true;
    }

    router.push('/');
    return false;
  }, [router]);
};
